import React, { useEffect, useState } from 'react'
import adminServices from '../../services/AdminServices'
import utils from '../../utils'
import { FaStoreAlt } from 'react-icons/fa'
import { FaXmark, } from 'react-icons/fa6'
import { FiCheckCircle } from "react-icons/fi";

function StoreStats() {
    const [stats, setStats] = useState()

    useEffect(() => {
        getStoreStats()
    }, [])

    const getStoreStats = () => {
        adminServices.adminStoreStats().then(
            res => {
                setStats(res.data)
            },
            err => {
                console.log(err);

            }
        )
    }
    return (
        <div>
            <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
                <div className="bg-white p-6 rounded-lg shadow">
                    <div className="flex items-start justify-between">
                        <div>
                            <p className="text-sm font-medium text-gray-500">Total Stores</p>
                            <p className="text-3xl font-bold text-gray-900 mt-2">{utils.toCommas(stats?.stores_count || 0)}</p>
                        </div>
                        <div className="p-2 bg-orange-100 rounded-full">
                            <span className="material-icons text-secondary"><FaStoreAlt className='h-7 w-7' /></span>
                        </div>
                    </div>
                </div>
                <div className="bg-white p-6 rounded-lg shadow">
                    <div className="flex items-start justify-between">
                        <div>
                            <p className="text-sm font-medium text-gray-500">Verified</p>
                            <p className="text-3xl font-bold text-gray-900 mt-2">{utils.toCommas(stats?.verified_count || 0)}</p>
                        </div>
                        <div className="p-2 bg-red-100 rounded-full">
                            <span className="material-icons text-primary"><FiCheckCircle className='h-7 w-7' /></span>
                        </div>
                    </div>
                </div>
                <div className="bg-white p-6 rounded-lg shadow">
                    <div className="flex items-start justify-between">
                        <div>
                            <p className="text-sm font-medium text-gray-500">Unverified</p>
                            <p className="text-3xl font-bold text-gray-900 mt-2">{utils.toCommas(stats?.unverified_count || 0)}</p>
                        </div>
                        <div className="p-2 bg-orange-100 rounded-full">
                            <span className="material-icons text-secondary"><FaXmark className='h-7 w-7' /></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default StoreStats